export interface FilterTypes {
  type: string;
  name: string;
  required?: string;
  placeholder?: string;
  checked?: boolean;
  values?: any;
  value?: any;
  options?: {};
  operator?: string;
  disabled?: boolean;
  indeterminate?: boolean;
  labelPosition?: string;
  maxLength?: number;
  minLength?: number;
  overrideFieldName?: string;
}

export enum FilterDefaultValues {
  TextDefault = '-',
}

export class FilterField {
  name: string;
  value?: any;
}
